(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instagram"] && !Shopify.designMode) return;
  try {
    
  fetch(`https://d3ejra0xbg20rg.cloudfront.net/instagram/media?shop=${Shopify.shop}&resource=default`).then(function(response) {
    return response.json();
  }).then(function(media) {
    for (var i = 0; i < 9; i++){
      $(".photo_list").append("<li class='item'><a href="+ media[i].permalink+" target='_blank'><img class='lazyload' data-src="+ media[i].media_url+" alt=''></a></li>");
    }
  }).catch(function() {
    $("#shopify-section-instagram").hide();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp_content"]) return;
  try {
    
  $(window).scroll(function () {
    $('.lp_howto').each(function () {
      var howto = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll > howto - windowHeight + windowHeight / 5) {
        $('.product_bar').removeClass('off');
      } else {
        $('.product_bar').addClass('off');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recruit"] && !Shopify.designMode) return;
  try {
    
  $(".recruit_list dt").click(function () {
    $(this).toggleClass("open");
  });

  } catch(e) { console.error(e); }
})();
})();
